import { BaseContext } from '../../../utils/basecontext';
import { ToneDto } from '../../../core/dto/tonedto';
import { ListTonesDto } from '../../../core/dto/listtones/listtonesdto';

export interface ListViewModel<T>
{
    setListDatas(listOfDatas: T[]): void;
    deleteData(id: string): void;
    deleteListToneData(listToneDto:ListTonesDto):void;
    getItem(position: number): T;
    getCount(): number;
    getView(t: T, position: number): JSX.Element | boolean;
    getTitleCSSStyle(): object;
    getHeader():JSX.Element|boolean;
    getListOfDatas(): T[];
    setScrollToPosition(position: number, isScrollToPositionRequired: boolean): void;
    getScrollToPosition(): number;
    getIsScrollToPositionRequired(): boolean;
}

export class ListViewModelImpl<T> implements ListViewModel<T>
{
    private titleCSSStyle: object;
    private listOfDatas: T[];
    private scrollToPosition: number = 0;
    private isScrollToPositionRequired: boolean = false;

    constructor(private context: BaseContext)
    {
        this.listOfDatas = [];
    }
    getHeader(): boolean | JSX.Element {

        return false;
    }
    

    getContext(): BaseContext{
        return this.context;
    }


   
    setTitleCSSStyle(titleCSSStyle: object): void
    {
        this.titleCSSStyle = titleCSSStyle;
    }

    setListDatas(listOfDatas: T[]): void 
    {
        // this.listOfDatas.length = 0;
        
        this.listOfDatas = listOfDatas;
    }

    setScrollToPosition(position: number, isScrollToPositionRequired: boolean) {
      this.scrollToPosition = position;
      this.isScrollToPositionRequired = isScrollToPositionRequired;
    }

    getScrollToPosition(): number {
        return this.scrollToPosition;
    }

    getIsScrollToPositionRequired(): boolean {
       return this.isScrollToPositionRequired;
    }

    deleteData(id: string): void 
    {
        this.listOfDatas = this.listOfDatas.filter((t: any)=>
        {
            return (t as ToneDto).getId() !== id;
        });

        console.log("-------delete: id" + this.listOfDatas.length);
    }
    deleteListToneData(listToneDto:ListTonesDto):void
    {
        this.listOfDatas = this.listOfDatas.filter((t: any)=>
        {
            console.log("-------delete: id caller from list: " +(t.getId()+t.getCaller()+t.getTimeType()+t.getRepeats()));
            console.log("-------delete: id incoming" +(listToneDto.getId()+listToneDto.getCaller()+listToneDto.getTimeType()+listToneDto.getRepeats()));
            
                return (
                    t.getId()+t.getCaller()+t.getTimeType()+t.getRepeats().length 
                    !== listToneDto.getId()+listToneDto.getCaller()+listToneDto.getTimeType()+listToneDto.getRepeats().length);
             
        });
    }
    getItem(position: number): T 
    {
        return this.listOfDatas[position];
    }

    getCount(): number 
    {
        return this.listOfDatas.length;
    }

    getListOfDatas(): T[] {
        return this.listOfDatas;
    }

    getView(t: T, position: number): boolean | JSX.Element {
        throw new Error("Method not implemented.");
    }

    
    getTitleCSSStyle(): object {
        return this.titleCSSStyle;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/listviewmodel.tsx